import React from 'react';
import { Card } from 'antd';
import HeadingTypography from '../../shared/Typography/Heading';
import TextTypography from '../../shared/Typography/Text';

interface StatItem {
  title: string;
  value: string | number;
}

interface StatsCardsProps {
  data: Record<string, string | number> | StatItem[];
  cardClassName?: string;
  containerClassName?: string;
  titleSize?: number;
  valueSize?: number;
  cardBordered?: boolean;
}

const StatsCards: React.FC<StatsCardsProps> = ({
                                                 data,
                                                 cardClassName = 'rounded-xl shadow-md bg-white h-full',
                                                 containerClassName = 'pt-6',
                                                 titleSize = 16,
                                                 valueSize = 16,
                                                 cardBordered = false,
                                               }) => {
  // Convert object to array if needed
  const statsData = Array.isArray(data)
    ? data
    : Object.entries(data).map(([title, value]) => ({ title, value }));

  return (
    <div className={containerClassName}>
      <div className="flex w-full gap-4">
        {statsData.map((stat, index) => (
          <div key={index} className="flex-1 min-w-0">
            <Card bordered={cardBordered} className={cardClassName}>
              <div className="flex justify-between items-center">
                <HeadingTypography fontSize={16}>
                  {stat.title}
                </HeadingTypography>
                <TextTypography fontSize={16}>
                  {stat.value}
                </TextTypography>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsCards;
